import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";
import HubbleTableHeading from "./HubbleTableHeading";
import HubbleRequests from "services/hubble";
import HubbleTableItem from "./HubbleTableItems";

const HubbleTable = () => {
  const {
    hubbleForms,
    hubbleCurrentPage,
    hubbleTotalPages,
  } = useSelector(({ hubble }) => hubble);
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    dispatch(HubbleRequests.getHubbleList(value));
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {hubbleForms && hubbleForms.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <HubbleTableHeading />
          </TableHead>
          <TableBody>
            {hubbleForms.map((item) => (
              <HubbleTableItem row={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {hubbleForms.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={hubbleTotalPages}
            color="primary"
            page={hubbleCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default HubbleTable;
